import styled from 'styled-components/macro';
import { definitionLabel } from 'styles/base-classes';

export const Section = styled('section')`
  margin: ${({ theme }) => `0 0 ${theme.spacing.large}`};

  @media screen and (min-width: 43em) {
    margin: ${({ theme }) => theme.spacing.xlarge};
  }
`;

export const Heading = styled('h2')`
  ${definitionLabel};
  margin-bottom: 0;

  @media screen and (min-width: 43em) {
    margin-bottom: ${({ theme }) => theme.spacing.small};
  }
`;
